module.exports = __webpack_public_path__ + "img/1200.6b2b1923.jpg";